import * as z from "zod";

export enum TeamAnonymizationSource {
  StaleUninstalledTeam = "stale_uninstalled_team",
  ShopifyShopRedact = "shopify_shop_redact",
}

export const teamAnonymizationSchema = z.object({
  anonymizationDate: z.string().nullish(),
  wasAnonymized: z.boolean().nullish(),
  source: z.enum(TeamAnonymizationSource).nullish(),
});
export type TeamAnonymization = z.infer<typeof teamAnonymizationSchema>;
